"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENVIRONMENT = void 0;
var ENVIRONMENT;
(function (ENVIRONMENT) {
    ENVIRONMENT["DEMO"] = "demo";
    ENVIRONMENT["DEV"] = "dev";
    ENVIRONMENT["QA"] = "qa";
    ENVIRONMENT["V1"] = "v1";
    ENVIRONMENT["V2"] = "v2";
    ENVIRONMENT["V3"] = "v3";
})(ENVIRONMENT = exports.ENVIRONMENT || (exports.ENVIRONMENT = {}));
